<div class="dfTableContainer allFilesContainer">
  <div class="filterForm">
    <fieldset>
      <mat-form-field appearance="outline" floatLabel="always" >
        <mat-label>Search</mat-label>
        <input matInput class="form-control-textbox" name="filterSearch" [(ngModel)]="queryFilter.CourseKeyword" />
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Program</mat-label>
        <mat-select placeholder="All Programs" name="filterprogram"
          [(ngModel)]="queryFilter.CourseProgram">
          <mat-option value="0">All Programs</mat-option>
          @for (cp of coursePrograms; track cp) {
            <mat-option [value]="cp.id">{{
            cp.programName}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Tag</mat-label>
        <mat-select placeholder="All Tags" name="filtercoursetag"
          [(ngModel)]="queryFilter.Tag">
          <mat-option value="0">All Tags</mat-option>
          @for (tag of tags; track tag) {
            <mat-option [value]="tag.id">{{
            tag.tagName}}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Status</mat-label>
        <mat-select placeholder="All Statuses" name="filtercoursestatus" [(ngModel)]="queryFilter.CourseStatus">
          <mat-option value="0">All Statuses</mat-option>
          @for (cs of courseStatus; track cs) {
            <mat-option [value]="cs.key">
              {{cs.value}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </fieldset>
    <div class="form-buttons">
      <div class="filterButtons">
        <button class="submit-form-button" (click)="search()" #submitButton>Search</button>
        <button class="submit-form-button cancel-button no-margin" (click)="resetFilters()">Reset</button>
      </div>
    </div>
  </div>
  <div class="h-30"></div>
  <div class="tableContents">
    <ng-container #courseContainer *ngTemplateOutlet="courseTable; context: {data: courseList, headerVisible: true}"></ng-container>
    <mat-paginator #paginator [length]="this.totalRecords" [pageSize]="25" [hidden]="this.totalRecords === 0"
    [pageSizeOptions]="[10, 25, 50]" (page)="handlePageEvent($event)" ariaLabel=''></mat-paginator>
  </div>
</div>


<ng-template #courseTable let-data="data" let-headerVisible="headerVisible">
  <app-no-results #noResults></app-no-results>

  <table mat-table class="fileList primary" [dataSource]="data" [hidden]="data.length === 0">
    <ng-container matColumnDef="checkbox">
      <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Name"></th>
      <td mat-cell *matCellDef="let course">
        <mat-checkbox [checked]="isCourseSelected(course)" (change)="onCheckboxChange(course)"></mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Name">Course Name</th>
      <td mat-cell *matCellDef="let course">
        <a routerLink="/view-course/{{course.id}}">{{course.courseName}}</a>
      </td>
    </ng-container>
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Course Id">Id</th>
      <td mat-cell *matCellDef="let course">
        {{course.courseId}}
      </td>
    </ng-container>

    <ng-container matColumnDef="program">
      <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Program">Programs</th>
      <td mat-cell *matCellDef="let course">
        <ul class="stacked-list">
          @for (program of course.programs; track program) {
            <li>
              {{ program }}
            </li>
          }
        </ul>
      </td>
    </ng-container>
    @if (headerVisible) {
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="tableHeader"></tr>
    }
    <tr mat-row *matRowDef="let tags; columns: columnsToDisplay"></tr>
  </table>
</ng-template>
